/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Role } from '@src/app/model/role';

@Injectable({
    providedIn: 'root'
})
export class RoleService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl() {
        return this.getAjaxPath('settings/roles');
    }
    protected cache: Role[];
    protected typeString = 'Roles';
}
